import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[autoDashSSNFormat]',
  standalone: true
})
export class AutoDashSSNFormatDirective {
  private previousValue: string = '';

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInputChange(event: Event): void {
    const input = this.el.nativeElement;
    let value = input.value.replace(/\D/g, '');

    if (value.length > 9) {
      value = value.slice(0, 9);
    }

    if (value.length > 5) {
      value = value.replace(/(\d{3})(\d{2})(\d+)/, '$1-$2-$3');
    } else if (value.length > 3) {
      value = value.replace(/(\d{3})(\d+)/, '$1-$2');
    }

    input.value = value;

    if (this.previousValue !== value) {
      this.previousValue = value;
      input.dispatchEvent(new Event('input'));
    }
  }
}
